export { default } from "./useLegacyWritePromptGet";
